import { Link } from "react-router-dom";

export default function Platform() {
  return (
    <div style={{
      minHeight: "70vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "#f9fafb",
      padding: "40px 20px",
      textAlign: "center",
    }}>
      <div style={{ fontSize: "64px", marginBottom: "20px" }}>🌐</div>

      <h1 style={{
        fontFamily: "Sora, sans-serif",
        fontSize: "36px",
        fontWeight: "900",
        color: "#052e16",
        marginBottom: "12px",
      }}>
        Platform Coming Soon
      </h1>

      <p style={{
        fontSize: "16px",
        color: "#6b7280",
        maxWidth: "420px",
        lineHeight: "1.7",
        marginBottom: "32px",
      }}>
        We are currently building the EcoConnect platform.
        Please check back soon or contact us for more information.
      </p>

      <div style={{ display: "flex", gap: "14px", flexWrap: "wrap", justifyContent: "center" }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <button style={{
            padding: "12px 28px",
            background: "#16a34a",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            fontFamily: "Sora, sans-serif",
          }}>
            ← Back to Home
          </button>
        </Link>
        <Link to="/contact" style={{ textDecoration: "none" }}>
          <button style={{
            padding: "12px 28px",
            background: "white",
            color: "#16a34a",
            border: "1.5px solid #16a34a",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            fontFamily: "Sora, sans-serif",
          }}>
            Contact Us →
          </button>
        </Link>
      </div>
    </div>
  );
}